






import {Vue, Component} from "vue-property-decorator";
import {State} from "vuex-class";
import Shell from './components/Shell.vue';

@Component({components: {Shell}})
export default class App extends Vue {
    @State user;
}
